import React from 'react';
import styled from 'styled-components';
import { Checkbox } from '../../../atoms/inputs';
import { Content } from '../column';
import { colors } from '../../../styles';
import { textSizesPx, spaceSizesPx } from '@nauto/core';

export interface Props {
  className?: string;
  label: Content;
  starred?: boolean;
  checked: boolean;
  onCheck: () => void;
}

class ColumnCheckbox extends React.Component<Props> {
  render() {
    const { className, label, starred, checked, onCheck } = this.props;

    return (
      <div className={className} onClick={onCheck}>
        <Checkbox checked={checked} />
        <span className="label">{label}</span>
        {starred && <span className="customer-view">*</span>}
      </div>
    );
  }
}

export default styled(ColumnCheckbox)`
  padding: ${spaceSizesPx.md} ${spaceSizesPx.xs} ${spaceSizesPx.md} ${spaceSizesPx.md};
  display: flex;
  flex-flow: row;
  align-items: center;
  cursor: pointer;

  input {
    flex-shrink: 0;
  }

  .label {
    padding-left: ${spaceSizesPx.md};
    overflow: hidden;
    white-space: nowrap;
  }

  .customer-view {
    padding-left: ${spaceSizesPx.xs};
    font-family: Circular-Bold;
    font-size: ${textSizesPx.md};
    color: ${colors.green500};
  }

  &:hover {
    input:not(:checked) {
      background-color: ${colors.green10};
      box-shadow: 0 0 0 2px ${colors.green300};
    }

    .label {
      color: ${colors.green500};
    }
  }
`;
